<template>
  <div class="page-container has-action">
    <van-nav-bar
      class="payment-navbar"
      fixed
      title="提现"
      left-arrow
      @click-left="goableBack()" />
    <div class="withdraw">
      <div class="block">
        <div class="fs-18">
          提现金额
          <span class="fs-12 color-red"
            >（可提现余额{{ numFormat(userInfo.custAccount.balance) }}元）</span
          >
        </div>

        <van-field
          class="mt-10"
          type="number"
          v-model="amount"
          @blur="checkAmount"
          @input="onInput"
          :placeholder="withdrawTxt"
          :readonly="readonly">
          <div slot="left-icon">￥</div>
          <template #button>
            <van-button size="small" type="danger" @click="onAllWithdraw"
              >全部提现</van-button
            >
          </template>
        </van-field>
      </div>
      <div class="block">
        <van-field
          v-model="bankCard"
          readonly
          clearable
          input-align="right"
          label="银行卡"
          placeholder="请选择银行卡"
          @click="bankPicker.show = true"
          right-icon="arrow-down" />
        <van-field
          :value="userInfo.phone"
          label="手机号"
          input-align="right"
          disabled />
        <van-field
          v-model="payForm.wcode"
          type="number"
          maxlength="6"
          clearable
          placeholder="请输入6位验证码">
          <van-button
            :loading="smsForm.loading"
            loading-text="发送中..."
            @click="sendSms"
            plain
            :disabled="isSendSMSEnable"
            slot="button"
            size="small"
            type="danger"
            >{{ getSendBtnText }}</van-button
          >
        </van-field>
      </div>
    </div>
    <div class="page-action">
      <van-button
        class="payment-next-step"
        @click="onClickNext"
        type="danger"
        size="large"
        >确定</van-button
      >
    </div>
    <van-popup v-model="bankPicker.show" position="bottom">
      <van-picker
        show-toolbar
        value-key="tailTag"
        :columns="bankPicker.columns"
        :loading="bankPicker.loading"
        @cancel="bankPicker.show = false"
        @confirm="confirmBankPicker" />
    </van-popup>
    <!-- 添加图片滑动解锁 -->
    <PhotoSlide
      ref="slideblock"
      @success="onSlideSuccess"
      sliderText="向右滑"
      :show="false"
      :showSlidePop.sync="showSlidePop"></PhotoSlide>
  </div>
</template>

<script>
import { Decimal } from "decimal.js"
import * as PayApi from "@/api/pay"
import * as CustApi from "@/api/cust"
import {
  NavBar,
  Button,
  Radio,
  Toast,
  Field,
  Checkbox,
  Popup,
  Picker,
  Icon,
  Dialog
} from "vant"
import { mapGetters } from "vuex"
import PhotoSlide from "../../components/photoSlide.vue"

export default {
  data() {
    return {
      readonly: false,
      bankCard: "",
      withdrawTxt: "请输入提现金额",
      //  用户选择银行卡
      bankPicker: {
        show: false,
        loading: false,
        columns: []
      },
      amount: "",
      single: false,
      payForm: {
        wcode: "",
        amount: "",
        bindCardId: "", // 用户选择的银行卡的银行id
        terminal: "H5"
      },
      smsForm: {
        loading: false,
        smsCountDown: 0,
        smsInterval: null
      },
      showSlidePop: false // 是否显示滑块解锁框
    }
  },
  /**
   * 提现规则：
   * 1.提现金额可输入精确到分
   * 2.当输入提现金额后，如果剩余可提现金额小于1元，须全部提出
   * 例：客户余额有1376.73元，输入提现1376元，余额小于1元了，须全部提现，系统自动跳转成提现1376.73元
   * 3.如当前客户余额已小于1元，提现时默认全部提现，且不可更改金额
   */
  beforeMount() {
    if (this.userInfo.custAccount.balance < 100) {
      this.readonly = true
      this.amount = this.userInfo.custAccount.balance / 100
      Dialog.alert({
        title: "温馨提示",
        message: "当前可提现金额小于1元，须全部提现"
      }).then(() => {})
    }
    this.getBankList()
    // if (this.channel.toLowerCase() === "yt") {
    //   CustApi.getChanlWithdraw()
    //     .then((data) => {
    //       if (data) {
    //         this.payForm.amount = data / 100;
    //         this.readonly = true;
    //       }
    //     })
    //     .catch(e => {
    //       console.error(e)
    //     });
    // } else {
    //   //this.init();
    // }
  },
  watch: {
    amount: function (val) {
      if (val.length > 0) {
        val = val.replace(/[^\d.]/g, "") //清除非数字和小数点的字符
        val = val.replace(/\.{2,}/g, ".") //清除第二个小数点
        val = val.replace(/^\./g, "") //验证第一个字符是数字而不是字符
        val = val.replace(".", "$#$")
        val = val.replace("/./g", "")
        val = val.replace("$#$", ".")
        val = val.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3") //保留两位小数
        // value = val.indexOf(".") > 0 ? value.split(".")[0].substring(0,7)+'.'+value.split(".")[1]//保留7位正整数
        this.payForm.amount = new Decimal(val).mul(100).toFixed()
      }
      this.amount = val
    }
  },
  computed: {
    isSendSMSEnable() {
      return this.smsForm.smsCountDown !== 0
    },
    getSendBtnText() {
      if (this.smsForm.smsCountDown > 0) {
        return this.smsForm.smsCountDown
      } else {
        return "获取验证码"
      }
    },
    ...mapGetters(["userInfo", "channel"])
  },

  methods: {
    onInput(value) {
      if ((value == 0 || value === ".") && !this.single) {
        this.amount = "0."
        this.single = true
      }
      if (value === "") {
        this.amount = ""
        this.single = false
      }
    },
    // 失去焦点，如果金额小于最小起购金额。自动填充最小金额
    checkAmount() {
      if (this.userInfo.custAccount.balance - this.amount * 100 < 100) {
        // Toast("根据您输入的提现金额，账户剩余额度不足1元，是否全部提现？")
        this.amount = this.userInfo.custAccount.balance / 100
      }
      if (!this.amount || this.amount.length == 0) {
        Toast("请输入提现金额")
        return false
      }

      //   if (this.payForm.amount.toString().indexOf(".") > 0) {
      //     Toast("提现金额必须是整数");
      //     this.payForm.amount = Math.ceil(this.payForm.amount);
      //     return;
      //   }
    },
    onAllWithdraw() {
      this.amount = this.userInfo.custAccount.balance / 100
    },

    getBankList() {
      this._showLoading()
      this.bankPicker.loading = true
      CustApi.listBindCard()
        .then((data) => {
          this._dismissLoading()
          if (!data || !data.length) {
            return
          }

          this.bankPicker.columns = data
          this.bankPicker.loading = false
          this.bankCard = data[0].tailTag
          this.payForm.bindCardId = data[0].id
        })
        .catch((e) => {
          this._dismissLoading()
          Toast(e.msg || e.message)
        })
    },

    // 提现
    onClickNext() {
      if (this.checkAmount() === false) {
        return
      }

      if (!this.payForm.bindCardId) {
        Toast("请先选择银行卡!")
        return
      }
      if (!this.payForm.wcode) {
        Toast("请先输入验证码!")
        return
      }
      // this.payForm.amount = this.amount * 100
      this._showLoading()
      PayApi.fundoutclaimer(this.payForm)
        .then((data) => {
          this._dismissLoading()
          if (!data) {
            Toast("服务器繁忙, 请稍后再试")
            return
          }
          this.$router.replace({
            path: "/withdraw/succ",
            query: {
              amount: this.amount
            }
          })
        })
        .catch((e) => {
          this._dismissLoading()
          Toast(e.msg || e.message)
        })
    },

    // 确认选择银行卡
    confirmBankPicker(value) {
      this.bankCard = value.tailTag
      this.payForm.bindCardId = value.id
      this.bankPicker.show = false
    },
    sendSms() {
      this.showSlidePop = true
    },
    //滑块验证方法
    onSlideSuccess() {
      this.showSlidePop = false
      this.$refs.slideblock.reset()
      this.onSendCode()
    },
    //请求验证码接口
    onSendCode() {
      this.smsForm.loading = true
      CustApi.withdrawcode()
        .then((data) => {
          this.smsForm.loading = false
          this.startSMSTimer()
        })
        .catch((e) => {
          this.smsForm.loading = false
          Toast(e.msg || e.message)
        })
    },
    startSMSTimer() {
      this.smsForm.smsCountDown = 60
      this.smsForm.smsInterval = setInterval(() => {
        this.smsForm.smsCountDown--
        if (this.smsForm.smsCountDown <= 0) {
          clearInterval(this.smsForm.smsInterval)
        }
      }, 1000)
    }
  },

  components: {
    [NavBar.name]: NavBar,
    [Button.name]: Button,
    [Radio.name]: Radio,
    [Toast.name]: Toast,
    [Field.name]: Field,
    [Checkbox.name]: Checkbox,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Icon.name]: Icon,
    PhotoSlide
  }
}
</script>

<style lang="less" scoped>
.payment_1 {
  .bank_name {
    line-height: 1;
    font-size: 12px;
    text-align: right;
  }
  .bank_quota {
    color: rgb(159, 173, 174);
    font-size: 10px;
    width: 140px;
    display: inline-block;
    line-height: 1;
    margin-top: 4px;
    margin-right: -10px;
  }
}
</style>
